import React, { useState } from 'react';
import i18next from 'i18next';
import '../Seats/AllParty.css';

const Party = ({ rows = [] }) => {
  const allParty = rows;
  const [expanded, setExpanded] = useState(() => new Set());

  const toggleRow = (key) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  return (
    <div className="party-table-wrap">
      <table className="party-table">
        <thead>
          <tr>
            <th aria-label="icon" />
            <th className="party-table__col-party">{i18next.t('联盟')}</th>
            <th>{i18next.t('提名')}</th>
            <th>{i18next.t('中选')}</th>
          </tr>
        </thead>
        <tbody>
          {allParty.map((row) => {
            const hasChildren = Array.isArray(row.parties) && row.parties.length > 0;
            const isOpen = expanded.has(row.key);
            return (
              <React.Fragment key={row.key}>
                <tr
                  className={`party-row ${hasChildren ? 'is-expandable' : ''} ${
                    isOpen ? 'is-open' : ''
                  }`}
                  onClick={hasChildren ? () => toggleRow(row.key) : undefined}
                >
                  <td className="party-table__icon">
                    {row.icon && <img src={row.icon} alt="" />}
                  </td>
                  <td className="party-table__col-party">
                    {hasChildren && (
                      <span className="party-table__caret" aria-hidden="true">
                        {isOpen ? '▾' : '▸'}
                      </span>
                    )}
                    {i18next.t(row.party)}
                  </td>
                  <td>{row.num}</td>
                  <td>{row.win}</td>
                </tr>
                {isOpen &&
                  row.parties.map((sub, idx) => (
                    <tr key={`${row.key}-${idx}`} className="party-row party-row--sub">
                      <td>
                        
                      </td>
                      <td className="party-table__col-party">{sub.icon && <img src={sub.icon} alt="" />} {sub.partys}</td>
                      <td>{sub.nums || 0}</td>
                      <td>{sub.wins || 0}</td>
                    </tr>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Party;
